import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import ManualDDRows from './ManualDDRows';
import ContributionKsRows from './ContributionKsRows';
import ContributionSlRows from './ContributionSlRows';

class ContributionDetails extends Component{
    constructor(props){
        super(props)
        this.state = {
            loading: true,
            usrMemberSetId: null
        }
    }

    static getDeriveStateFromProps(props, state){
        return {
            usrMemberSetId: props.match.params.usrMemberSetId
        }
    }

    componentDidMount(){
        this.props.startLoadingMemberContribution(this.props.match.params.usrMemberSetId);
    }

    // makeColumns(){
    //     this.props.futureStrategy.
    // }

    render(){
        const {t} = this.props
        //const slPercent = []
        console.log(this.props.memberContribution)
        return(
            <div>
                <h2 style={{color: "#52800a", fontSize:"21.3333px", marginLeft: "10px"}}>{t('contribution:pageHeader')}</h2>
    
                {!this.props.memberContribution ? <div style={{marginLeft: "10px", marginTop: "10px"}}>Fetching Contribution Details....</div> :
                    <div>
                        {this.props.memberContribution.hasSlRows ?
                            <ContributionSlRows {...this.props}/>
                            :<></>
                        }
                        
                        {this.props.memberContribution.hasManualDdRows ?
                            <ManualDDRows {...this.props} />
                            :<></>
                        }
                        {this.props.memberContribution.hasKsRows ?
                            <ContributionKsRows {...this.props} />
                            :<></>
                        }
                    </div>
                }
            </div>
            
        )
    }
}
export default withTranslation()(ContributionDetails);